import { getErrorMsg, logger } from 'lib/logger';
import { initProducts } from 'reactApp/modules/products/products.module';
import {
    loadQuotaLandingFailure,
    loadQuotaLandingRequest,
    loadQuotaLandingSuccess,
} from 'reactApp/modules/quotaLanding/quotaLanding.module';
import { handleSubscriptionsRequest } from 'reactApp/modules/subscriptions/subscriptions.saga';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { loadQuota } from 'reactApp/modules/userQuota/userQuota.saga';
import { all, cancel, put, select, takeEvery } from 'redux-saga/effects';

function* startLandingQuota() {
    const isAnonymous = yield select(UserSelectors.isAnonymous);

    if (isAnonymous) {
        yield put(loadQuotaLandingSuccess());
        return;
    }

    try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        yield all([loadQuota(), handleSubscriptionsRequest()]);
        yield put(initProducts());

        yield put(loadQuotaLandingSuccess());
    } catch (error) {
        logger.error(getErrorMsg(error), error);
        yield put(loadQuotaLandingFailure());
        yield cancel();
    }
}

export function* watchQuotaLanding() {
    yield takeEvery(loadQuotaLandingRequest.toString(), startLandingQuota);
}
